import { INVENTORY_QUERY_FRAGMENT } from '../../../../common/inventory/services/InventoryService';
import { BaseGQLService } from '../../../../common/services/BaseGQLService';
import { ModelType } from '../../../../common/utils/GQLIdEncoder';
import { ReportExportOptions } from '../../../options/ReportExportOptions';
import { ReportCsvMapper } from '../mappers/ReportCsvMapper';
import { ReportCsvData } from '../models/ReportCsvData';

export const GET_REPORT_CSV_QUERY = `
query ($reportId: ID!, $includeFilteredRules: Boolean!, $instancesKeptByFilters: Boolean) {
  report: node(id: $reportId) {
    ... on ReportDone {
      rules(includeFilteredRules: $includeFilteredRules) {
        edges {
          node {
            id
            number
            title
            shortExplanation
            severity
            instances(keptByFilters: $instancesKeptByFilters) {
              edges {
                node {
                  id
                  numberLocal
                  severity
                  data
                  filterStatus
                }
              }
            }
          }
        }
      }
      inventory {
        ${INVENTORY_QUERY_FRAGMENT}
      }
      objectStats {
        type
        value
        count
      }
    }
  }
}
`;

export class ReportCsvRepository extends BaseGQLService {
  private readonly mapper = new ReportCsvMapper();

  protected addTypename(): boolean {
    return false;
  }

  async getReport(reportId: number, options: ReportExportOptions): Promise<ReportCsvData> {
    const { includeFilteredRules } = options;
    return this.query(
      GET_REPORT_CSV_QUERY,
      {
        reportId: this.gqlIdEncoder.encode(ModelType.Report, reportId),
        includeFilteredRules,
        instancesKeptByFilters: includeFilteredRules ? null : true,
      },
      (data) => this.mapper.mapGQLModel(data.report)
    );
  }
}
